import React from "react"
import PropTypes from "prop-types"
import { withPrefix } from "gatsby"

import Icon from "@airasia/phoenix-components/components/Icon"
import Link from "@airasia/phoenix-components/components/Link"
import { addForwardslashToLinks } from "../utils/functions"

const Breadcrumb = props => {
  const {
    crumbs,
    accessible,
    linkColor,
    linkSize,
    linkHoverColor,
    linkHoverUnderlined,
    linkUnderlined,
    linkTarget,
    iconColor,
    iconSize,
  } = props

  const linkProps = {
    accessible,
    color: linkColor,
    size: linkSize,
    hoverColor: linkHoverColor,
    hoverUnderlined: linkHoverUnderlined,
    target: linkTarget,
    underlined: linkUnderlined,
  }

  const iconProps = {
    accessible,
    color: iconColor,
    fontsize: iconSize,
    icon: "ChevronRightIcon",
  }

  return crumbs.map((key, index) => {
    return index !== crumbs.length - 1 ? (
      <Link
        key={key}
        // redirection hotfix
        //href={key.label === "airasia" || key.label === "แอร์เอเชีย" ? withPrefix(key.path) : withPrefix(addForwardslashToLinks(key.path))}
        //{...linkProps}
        color="neutral"
        hoverUnderlined={false}
      >
        {key.label}
        <Icon {...iconProps} />
      </Link>
    )
    : (
      <Link
        key={key}
        // redirection hotfix
        href={key.label === "airasia" || key.label === "แอร์เอเชีย"? withPrefix(key.path) : withPrefix(addForwardslashToLinks(key.path))}
        size={linkSize}
        target={linkTarget}
        color="neutral"
        hoverUnderlined={false}
        accessible
      >
        {key.label}
      </Link>
    )
  })
}

Breadcrumb.propTypes = {
  crumbs: PropTypes.arrayOf(PropTypes.object).isRequired,

  accessible: PropTypes.bool,

  linkColor: PropTypes.string,
  linkSize: PropTypes.string,
  linkHoverColor: PropTypes.string,
  linkHoverUnderlined: PropTypes.bool,
  linkUnderlined: PropTypes.bool,
  linkTarget: PropTypes.string,

  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
}

Breadcrumb.defaultProps = {
  accessible: true,

  linkColor: "primary",
  linkSize: "normal",
  linkHoverColor: "neutral",
  linkHoverUnderlined: true,
  linkTarget: "self",

  iconColor: "neutral",
  iconSize: "normal",
}

export default Breadcrumb
